import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
  {
    title: "",
    items: [
      {
        title: "Dashboard",
        id: 1,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPDashboard`,
        active: false,
      },
      // {
      //   title: "Your Why",
      //   id: 2,
      //   type: "main", 
      //   path: `${process.env.PUBLIC_URL}/MMPYourwhy`,
      //   active: false,
      // },
      {
        title: "Income & Expenses",
        id: 3,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPIncomeExpenses`,
        active: false,
      },
      {
        title: "Assets & Liabilities",
        id: 4,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPAssetsLiabilities`,
        active: false,
      },
      {
        title: "Home Loan Simulator",
        id: 5,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPHomeloanSimulator`,
        active: false,
      },
      {
        title: "Home Loan Results",
        id: 6,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPHomeloanResults`,
        active: false,
      },
      {
        title: "Property Search",
        id: 7,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/MMPProperty`,
        active: false,
      },
      {
        title: "Investment Property",
        id: 7,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/InvestmentProperty`,
        active: false,
      },
      {
        title: "Feedback",
        id: 7,
        type: "main", 
        path: `${process.env.PUBLIC_URL}/Feedback`,
        active: false,
      },
    ],
  },
];
